module.exports = __webpack_public_path__ + "static/media/_wales.0a59df92.png";